import { useEffect } from 'react';
import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom';
import SettingsIcon from '@enerex/unified-ui-react/icons/SettingsIcon';
import UsersIcon from '@enerex/unified-ui-react/icons/UsersIcon';
import NotificationsIcon from '@enerex/unified-ui-react/icons/NotificationsIcon';
import InfoIcon from '@enerex/unified-ui-react/icons/InfoIcon';
import { useAuth } from 'providers/CustomAuthProvider';
import './settings.scss';

const Settings = () => {
    const { pathname } = useLocation();
    const { isAdmin, isSystemAdmin } = useAuth();

    useEffect(() => {
        document.title = 'DataHub - Settings';
    }, []);

    const items = [
        { title: 'General', path: 'general', icon: <SettingsIcon /> },
        { title: 'Users', path: 'users', icon: <UsersIcon />, hidden: !isAdmin },
        { title: 'Following', path: 'subscriptions', icon: <NotificationsIcon /> },
        { title: 'SystemAdmin Settings', path: 'systemadmin', icon: <SettingsIcon />, hidden: !isSystemAdmin },
        { title: 'Excluded Domains', path: 'excluded-domains', icon: <SettingsIcon />, hidden: !isSystemAdmin },
        { title: 'Lookup', path: 'lookup', icon: <InfoIcon />, hidden: !isSystemAdmin },
        { title: 'Template Studio', path: 'template-studio', icon: <SettingsIcon /> },
    ];

    return (
        <section className="settings-page" aria-labelledby="settings-title">
            <h1 id="settings-title" className="settings-page__title">Settings</h1>
            <div className="settings-page__layout">
                <nav className="settings-navigation" aria-label="Settings">
                    {items.filter((item) => !item.hidden).map((item) => (
                        <NavLink
                            key={item.path}
                            to={`/settings/${item.path}`}
                            className={({ isActive }) => `settings-navigation__link${isActive ? ' settings-navigation__link--active' : ''}`}
                        >
                            <span className="settings-navigation__icon" aria-hidden="true">{item.icon}</span>
                            <span>{item.title}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="settings-page__content">
                    {/^\/settings\/?$/.test(pathname) ? <Navigate to="/settings/subscriptions" replace /> : <Outlet />}
                </div>
            </div>
        </section>
    );
};

export default Settings;
